import React, { useState } from 'react';
import {
  TextField,
  Button,
  Grid,
  Box,
  Card,
  CardContent,
  Snackbar,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useCreateBrandMutation } from 'state/api';
import { PageContainer } from 'components/shared';

const BrandSetup = () => {
  const [brandName, setBrandName] = useState('');
  const [description, setDescription] = useState('');
  const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

  const [createBrand, { isLoading }] = useCreateBrandMutation();

  const notify = (msg, severity = 'success') => setSnack({ open: true, msg, severity });

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!brandName.trim()) {
      notify('Brand name is required', 'error');
      return;
    }
    try {
      await createBrand({ name: brandName.trim(), description: description.trim() }).unwrap();
      notify('Brand created successfully');
      setBrandName('');
      setDescription('');
    } catch (err) {
      notify(err?.data?.message || 'Failed to create brand', 'error');
    }
  };

  const handleReset = () => {
    setBrandName('');
    setDescription('');
  };

  return (
    <PageContainer
      title="Add Brand"
      subtitle="Create a new brand for your product catalogue"
    >
      <Card>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Brand Name"
                  fullWidth
                  margin="normal"
                  name="brandName"
                  value={brandName}
                  onChange={(e) => setBrandName(e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Description"
                  fullWidth
                  multiline
                  minRows={2}
                  margin="normal"
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
              <Button type="button" variant="outlined" onClick={handleReset} disabled={isLoading}>
                Reset
              </Button>
              <Button type="submit" variant="contained" color="primary" disabled={isLoading}>
                {isLoading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snack.severity} onClose={() => setSnack((s) => ({ ...s, open: false }))}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </PageContainer>
  );
};

export default BrandSetup;
